import { Injectable }    from '@angular/core';
import { environment } from 'src/environments/environment';
import {SupplierAuctionOfferListModel, SupplierAuctionOfferModel} from 'src/common';
import {SearchModel, SearchResultModel} from 'src/common';
import {HttpClient} from '@angular/common/http';



const localApiUrl = `${environment.apiUrl}/SupplierAuctionOffer`;

@Injectable()
export class SupplierAuctionOfferService {

  constructor(private http: HttpClient) { }

  search(search: SearchModel): Promise<SearchResultModel<SupplierAuctionOfferListModel>> {
      return this.http.post<SearchResultModel<SupplierAuctionOfferListModel>>(`${localApiUrl}/Search`, search).toPromise();
  }

  getAll(): Promise<SupplierAuctionOfferListModel[]> {
	return this.http.get<SupplierAuctionOfferListModel[]>(`${localApiUrl}/All`).toPromise();
  }

  getById(id: number): Promise<SupplierAuctionOfferModel> {
    return this.http.get<SupplierAuctionOfferModel>(`${localApiUrl}/Details/${id}`).toPromise();
  }

  delete(id: number): Promise<void> {
	return this.http.get<void>(`${localApiUrl}/Delete/${id}`).toPromise();
  }

  save(model: any): Promise<void> {
    return this.http.post<void>(`${localApiUrl}/Save`, model).toPromise();
  }

  // custom-start

  changeStatus(model: any): Promise<void> {
    return this.http.post<void>(`${environment.apiUrl}/SupplierRound/ChangeStatus`, model).toPromise();
  }

  acceptAuction(model: any): Promise<void> {
    return this.http.post<void>(`${environment.apiUrl}/SupplierRound/AcceptAuction`, model).toPromise();
  }

  // custom-end

}



